/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRank8S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.93 12.698c.207.2.31.457.31.77 0 .327-.11.584-.33.77-.213.187-.517.28-.91.28-.387 0-.69-.093-.91-.28-.22-.186-.33-.443-.33-.77 0-.313.103-.57.31-.77.213-.206.523-.346.93-.42.413.074.723.214.93.42zm-.14-3c.18.14.27.347.27.62 0 .247-.09.457-.27.63-.18.167-.443.287-.79.36-.347-.073-.61-.193-.79-.36a.842.842 0 0 1-.27-.63c0-.273.09-.48.27-.62s.443-.21.79-.21.61.07.79.21z" />
        <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM10.14 8.798c.44-.34 1.06-.51 1.86-.51s1.42.17 1.86.51.66.817.66 1.43c0 .434-.153.81-.46 1.13a2.3 2.3 0 0 1-.579.428c.09.039.177.083.259.132.307.18.543.414.71.7.173.28.26.597.26.95 0 .674-.24 1.2-.72 1.58-.473.38-1.137.57-1.99.57-.847 0-1.51-.19-1.99-.57s-.72-.906-.72-1.58c0-.353.083-.67.25-.95a2.04 2.04 0 0 1 .976-.833 2.301 2.301 0 0 1-.576-.427 1.58 1.58 0 0 1-.46-1.13c0-.613.22-1.09.66-1.43z" />
      </g>
    </g>
  </Icon>
);
export { SvgRank8S as Rank8S };
